import { type Nullable } from "@sunrise/utils";
import { channelByIdAtom, selectChannelLogo } from "@sunrise/yallo-channel";
import { useAtomValue } from "jotai";
import { selectAtom, unwrap } from "jotai/utils";
import { type ReactElement, forwardRef } from "react";

import { ChannelBox } from "@/components/boxes";
import type { ChannelResult } from "@sunrise/backend-types";

export type ListChannelItemProps = CommonProps & {
  item: ChannelResult["items"][number];
  focused: boolean;
  posterUrl: Nullable<string>;
  className?: string;
  "data-position"?: number;
};

export const ListChannelItem = forwardRef<HTMLDivElement, ListChannelItemProps>(
  function ListChannelItem(
    {
      "data-testid": dataTestId = "column-item-channel",
      "data-position": dataPosition,
      focused,
      className,
      style,
      ...props
    },
    ref,
  ): ReactElement {
    const logoUrl = useAtomValue(
      selectAtom(
        unwrap(channelByIdAtom(props.item.details.id)),
        selectChannelLogo,
      ),
    );

    return (
      <ChannelBox
        style={style}
        ref={ref}
        coverImageUrl={props.posterUrl}
        logoUrl={logoUrl}
        focused={focused}
        className={className}
        data-testid={dataTestId}
        data-focused={focused}
        data-position={dataPosition}
      />
    );
  },
);
